import { Auth } from '@aws-amplify/auth';
import type {
  CognitoIdToken,
  CognitoRefreshToken,
  CognitoAccessToken,
} from 'amazon-cognito-identity-js';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface ICognitoUserSession {
  getAccessToken: () => CognitoAccessToken;
  getIdToken: () => CognitoIdToken;
  getRefreshToken: () => CognitoRefreshToken;
  isValid: () => boolean;
}

const getAuthUser = async (): Promise<ICognitoUserSession> => {
  return Auth.currentSession();
};

interface IUseAuthReturnValue {
  authUser: ICognitoUserSession | undefined;
  isLoading: boolean;
}

export const useAuth = (): IUseAuthReturnValue => {
  const location = useLocation();
  const [authUser, setAuthUser] = useState<ICognitoUserSession | undefined>();
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAuthUser = async (): Promise<void> => {
      setLoading(true);

      try {
        const authUserData = await getAuthUser();
        setAuthUser(authUserData);
      } catch {
        // eslint-disable-next-line unicorn/no-useless-undefined
        setAuthUser(undefined);
      } finally {
        setLoading(false);
      }
    };

    void fetchAuthUser();
  }, [location]);

  return { authUser, isLoading };
};
